import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./CaseStudyList.module.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import SeoPage from "../../components/seo/SeoPage";

const CaseStudyList = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  // 👉 Data kept inside same page
  const caseStudies = [
    {
      id: 1,
      title: "Driving Revenue Through Intelligent Fleet Automation",
      description:
        "Automating Driver Rostering and Compliance for a Leading Singapore Ride-Hailing Operator.",
      link: "/case-studies/intelligent-fleet-automation-revenue-growth",
    },
    {
      id: 2,
      title:
        "Ensuring Stability in Agritech SaaS: Leadership Transition Without Disruption",
      description:
        "Stabilized a rapidly growing Agritech SaaS platform during a critical leadership transition, ensuring zero",
      link: "/case-studies/agritech-saas-leadership-transition-stability",
    },
    // {
    //   id: 3,
    //   title: "Ferrari",
    //   description:
    //     "Delivering real-time performance insights and advanced analytics to power smarter operations.",
    // },
    // {
    //   id: 4,
    //   title: "US Open",
    //   description:
    //     "Creating immersive fan experiences with AI and next-gen digital platforms.",
    // },
  ];

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {" "}
      <SeoPage
        title="Our Success Stories | Bharat Clouds Private Limited"
        description="Take a over-view of our success stories showcasing innovation, measurable business impact we served. Read inspiring stories across industries"
      />
      <div className="container my-5">
        {/* Heading */}
        <div className="text-center mt-5 custom-space custom-space-padding">
          <h5 className="main_heading mt-4">
            Real-World Success Stories Powered by Bharat Clouds
          </h5>

          <p className="main_subheading pb-4">
            Explore how Bharat Clouds helps organizations modernize
            infrastructure, streamline operations, and accelerate digital
            transformation through secure and scalable cloud solutions. Discover
            real case studies that showcase measurable results, improved
            efficiency, and lasting business impact across industries.
          </p>
        </div>

        {/* Accordion */}
        {caseStudies.map((item, index) => (
          <div
            key={item.id}
            className={`${styles.row} ${
              activeIndex === index ? styles.active : ""
            }`}
          >
            {/* Header */}
            <div className={styles.header} onClick={() => toggle(index)}>
              <h4 className={styles.title}>{item.title}</h4>

              <span className={styles.icon}>
                {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>

            {/* Content */}
            {activeIndex === index && (
              <div className={styles.content}>
                <p>{item.description}</p>

                <button
                  className={styles.readBtn}
                  onClick={() => navigate(item.link)}
                >
                  Read the case study →
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default CaseStudyList;
